import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BatchQuotesService {

  constructor(private http: HttpClient) { }

  getShipmentFromQuote(id): Observable<any> {
    return this.http.get(`${environment.url}/batch-quotes/by/shipmentId`, {
      params: {
        shipmentId: id,
        type: 'posting'
      }
    });
  }

  getCurrentLoadsByUser(userId: string): Observable<any> {
    return this.http.get(`${environment.url}/batch-quotes/current-loads/${userId}`)
  }
}